import { HttpClient } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTab, MatTabGroup } from "@angular/material/tabs";
import { BillingReport, CardChargeLog, PaymentAmountDetail, PaymentHisotryItem } from "../../../clients.models";
import { AsyncPipe, DatePipe } from "@angular/common";
import { BoolToImgPipe } from "../../../../_infrastructure/pipes";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { env } from "../../../../../env/env";
import { Observable } from "rxjs";
import { BillingReportСomponent } from "../../components/billing-report/billing-report";

@Component({
    templateUrl: 'payment-history-details-dialog.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: 'payment-history-details-dialog.css',
    imports: [
        MatDialogModule,
        MatTab,
        MatTabGroup,
        MatTableModule,
        DatePipe,
        BoolToImgPipe,
        ScrollingModule,
        AsyncPipe,
        BillingReportСomponent
    ]
})
export class PaymentHistoryDetailsDialog {
    constructor(
        private httpClient: HttpClient,
        @Inject(MAT_DIALOG_DATA) public data: { clientId: string, item: PaymentHisotryItem }) {
    }

    public billingReport$: Observable<BillingReport> | null = null;
    public cardChargeLog: MatTableDataSource<CardChargeLog> = new MatTableDataSource<CardChargeLog>;
    public amountDetails: MatTableDataSource<PaymentAmountDetail> = new MatTableDataSource<PaymentAmountDetail>();
    public ngOnInit() {
        this.loadAmountDetails();
    }

    private loadAmountDetails() {
        this.httpClient.get<PaymentAmountDetail[]>(`${env.apiUrl}/clients/${this.data.clientId}/payment/history/${this.data.item.id}/amount-details`).subscribe(details => {
            this.amountDetails.data = details;
        });
    }

    private loadBillingReport() {
        this.billingReport$ = this.httpClient.get<BillingReport>(`${env.apiUrl}/clients/${this.data.clientId}/payment/history/${this.data.item.id}/report`);
    }

    private loadCardChargeLog() {
        this.httpClient.get<CardChargeLog[]>(`${env.apiUrl}/clients/${this.data.clientId}/payment/history/${this.data.item.id}/card-charge-logs`).subscribe(log => {
            this.cardChargeLog.data = log;
        });
    }

    public tabChanged($e: any): void {
        let tabIndex = $e.index as number;

        if (tabIndex == 1) {
            this.loadBillingReport();
        } else if (tabIndex == 2) {
            this.loadCardChargeLog();
        }
    }
}
